import { NavKendoRegister } from './kutils';
import "@kendo/kendo.datepicker.js";

export class InfDatePicker extends kendo.ui.DatePicker {
    constructor(element, options: kendo.ui.DatePickerOptions) {
        super(element, options);
    }

    /** Custom Handling Special Inputs hack : "hH", "1212", "12.12", ...*/
    private _update(v) {
        var custom = InfDatePicker.TranslateCustomInputValue(v);
        if (custom)
            v = custom;
        return super["_update"].call(this, v);
    }

    /** Try To Translate Input Value with Custom Logic */
    public static TranslateCustomInputValue(value: any): any {
        if (value == "h" || value == "H") {
            var d = new Date();
            d.setHours(0, 0, 0, 0);
            return d;
        } else if (value !== "" && typeof value == "string") {
            var parts: string[];
            if ((parts = value.split(/[.,\/ -]/).filter(item => item != "")).length < 3 && parts.length > 0) {
                // Handle "partial" input (day only, day.month only)
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                let year = today.getFullYear();
                var strNumbers = parts[0];
                if (parts.length == 1 && strNumbers.length >= 4 && strNumbers.length <= 8) {
                    // Input wOut '.' ... -> 0203, 020315, 02032015
                    switch (strNumbers.length) {
                        case 4:
                            var day = parseInt(strNumbers.substring(0, 2));
                            var month = parseInt(strNumbers.substring(2, 4));
                            break;
                        case 6:
                        case 8:
                            var day = parseInt(strNumbers.substring(0, 2));
                            var month = parseInt(strNumbers.substring(2, 4));
                            year = parseInt(strNumbers.substring(4, 8));
                            break;
                        default:
                        // ???
                    }
                } else {
                    var day = parseInt(parts[0]);
                    var month = parseInt(parts[1]) || (today.getMonth() + 1);
                }

                if (isNaN(year) || isNaN(month) || isNaN(day))
                    return;

                return day + "." + month + "." + year;
            }
        }
    }
}
NavKendoRegister(<any>InfDatePicker, "InfDatePicker", {
    parseFormats: ["dd.MM.yy"] // add w. short date
});

declare global {
    interface JQuery {
        /** Custom DatePicker  so far only parseFormat Extension generalized, TODO others : 'hH', ...*/
        kendoInfDatePicker(options: kendo.ui.DatePickerOptions): JQuery;
        data(key: "kendoInfDatePicker"): InfDatePicker;
    }
}
